import axios from 'axios';

const API_URL = '/api/worker/jobsites';

// Get all jobsites for the worker's employer
const getEmployerJobsites = async (token) => {
 
  
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const response = await axios.get(API_URL, config);
  return response.data;
};

const workerJobsitesService = {
  getEmployerJobsites,
};

export default workerJobsitesService;